<template>
  <div class="bg-light">
    <section>
      <nav-bar-component />
    </section>

    <div class="container bg-white py-4 px-5">
      <div v-show="!error">
        <p class="fs-2 fw-bolder">Olá, {{ customer_name }}</p>
        <p class="fw-lighter">Efetue o pagamento das faturas abaixo para concluir a contratação. Após a confirmação do
          pagamento, você receberá um e-mail com dados para seu primeiro acesso.</p>

        <hr>

        <iframe v-show="!!financial_panel_url" :src="financial_panel_url" width="100%" height="1000px" />
      </div>

      <div v-show="error" class="text-center">
        <div class="image">
          <img src="../assets/error-rd.svg" class="w-50 h-50">
        </div>

        <h4 class="fw-bolder my-3">Poxa, tivemos problemas para carregar sua fatura</h4>
        <p>Estamos passando por instabilidades, mas já estamos trabalhando nisso. Tente novamente em breve, ou entre em
          contato com o seu vendedor.</p>

        <button class="btn button-retry fw-bolder my-4" @click="reloadPage">Tentar Novamente</button>
      </div>
    </div>

    <footer>
      <footer-tallos-informations />
    </footer>

    <div :class="loadingDisplay" class="justify-content-center align-items-center w-100 opacity-50 overlay">
      <div class="spinner-border text-light" role="status" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { billingApiUrl, rdBillingApiUrl } from '@/config/runtime-config';


export default {
  name: "FinancialPanel",

  data() {
    return {
      customer_name: "",
      public_token: "",
      financial_panel_url: "",
      loading: true,
      error: false,
    };
  },

  computed: {
    subscriptionCode() {
      return this.$route.params.code;
    },
    customerId() {
      return this.$route.params.customer;
    },
    productFamily() {
      return this.subscriptionCode?.split(":")[0];
    },
    productCode() {
      return this.subscriptionCode?.split(":")[1];
    },
    companyId() {
      return this.productCode;
    },
    loadingDisplay() {
      return this.loading ? "d-flex" : "d-none";
    },
  },

  methods: {
    async getCustomerById() {
      this.config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}customer/${this.customerId}/company/${this.companyId}`,
        headers: {},
      };

      try {
        const result = await axios.request(this.config)

        this.customer_name = result.data.data.customer.name;
        this.public_token = result.data.data.customer.public_token

        this.makeFinancialPanelUrl();

        setTimeout(this.disableLoading, 500);
      } catch (error) {
        this.disableLoading()
        this.error = true;
      }

    },

    makeFinancialPanelUrl() {
      this.financial_panel_url = `${rdBillingApiUrl()}/accounts/${this.productCode}/subscription?account_token=${this.public_token}&product_code=${this.productFamily}&locale=pt-BR&tab=billing_and_invoices`;
    },

    disableLoading() {
      this.loading = false;
    },

    reloadPage() {
      window.location.reload();
    }
  },

  mounted() {
    this.getCustomerById();
  },
}
</script>

<style scoped>
.overlay {
  position: absolute;
  top: 9%;
  height: 91%;
  background: #212429;
}

.button-retry {
  background: #19C1CE;
  color: #212429;
  border-radius: 2px !important;
}
</style>